import { AxiosResponse } from "axios";
import { PickupCorporateConfig } from "@/domain/entities/PickupCorporateConfig";

export class PickupCorporateConfigMapper {
  public convertFromApi(response: AxiosResponse<any>): PickupCorporateConfig {
    const data = response.data?.data || {};
    const startHour = this.normalizeNumber(data.start_hour, 8);
    const endHour = this.normalizeNumber(data.end_hour, 23);

    if (startHour >= endHour) return new PickupCorporateConfig();

    return new PickupCorporateConfig({
      startHour,
      endHour,
      leadTimeHours: this.normalizeNumber(data.lead_time_hours, 4),
      armadaThresholdKg: this.normalizeNumber(data.armada_threshold_kg, 20)
    });
  }

  private normalizeNumber(value: unknown, fallback: number): number {
    const numberValue = Number(value);
    return Number.isFinite(numberValue) ? numberValue : fallback;
  }
}
